import React, { useState, useEffect } from 'react';
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { useCommandeContext, changeValeur } from "../../contexts/CommandeContext";

export default function Civilite({ props }) {

	// Initialisation de l'état par défaut
	const [valeur, setValeur] = useState('');

	// Recupération de la commande et du dispatcher à partir du CommandeContext
	const { commande, dispatch } = useCommandeContext();

	useEffect(() => {
		// Initialisation de la valeur à partir de la commande dans le context
		setValeur(commande[props.id]);
	}, [commande, props.id]);

	function handleChange(key, value) {
		setValeur(value);
		dispatch(changeValeur(key, value));
	}

	return (
		<FormControl fullWidth>
			<InputLabel id="civilite-label">{props.label}</InputLabel>
			<Select
				disabled={props.disabled}
				labelId="civilite-label"
				id={props.id}
				name={props.id}
				label={props.label}
				value={valeur}
				onChange={e => { handleChange(props.id, e.target.value) }}>
				<MenuItem value=''><em>Aucune</em></MenuItem>
				<MenuItem value='M.'>M.</MenuItem>
				<MenuItem value='Mme.'>Mme.</MenuItem>
			</Select>
		</FormControl>
	);
}